module.exports = __webpack_public_path__ + "img/gmdl_icon3.47b1469b.png";